/* Core Of Corporate product preview carousel — isolated enhancement */
(function(){
  function init(root){
    if(!root || root.dataset.cocSliderInit)return;
    const track=root.querySelector('[data-coc-track]');
    if(!track)return;
    const slides=[...track.querySelectorAll('[data-coc-slide]')];
    const prev=root.querySelector('[data-coc-prev]');
    const next=root.querySelector('[data-coc-next]');
    const count=root.querySelector('[data-coc-count]');
    if(slides.length<2){if(prev)prev.hidden=true;if(next)next.hidden=true;return;}
    root.dataset.cocSliderInit='true';
    let active=0,frame=0;
    function refresh(){
      const x=track.scrollLeft;let closest=0,distance=Infinity;
      slides.forEach((slide,i)=>{const d=Math.abs(slide.offsetLeft-slides[0].offsetLeft-x);if(d<distance){distance=d;closest=i;}});
      active=closest;
      if(count)count.textContent=(active+1)+' / '+slides.length;
      if(prev)prev.disabled=active===0;
      if(next)next.disabled=active===slides.length-1;
    }
    function go(i){
      const target=slides[Math.max(0,Math.min(slides.length-1,i))];
      track.scrollTo({left:target.offsetLeft-slides[0].offsetLeft,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
    }
    prev?.addEventListener('click',()=>go(active-1));
    next?.addEventListener('click',()=>go(active+1));
    track.addEventListener('scroll',()=>{if(!frame)frame=requestAnimationFrame(()=>{frame=0;refresh();});},{passive:true});
    track.addEventListener('keydown',e=>{if(e.key==='ArrowRight'){e.preventDefault();go(active+1);}else if(e.key==='ArrowLeft'){e.preventDefault();go(active-1);}});
    window.addEventListener('resize',refresh,{passive:true});
    refresh();
  }
  function boot(scope){(scope||document).querySelectorAll('[data-coc-story]').forEach(init)}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>boot());else boot();
  document.addEventListener('shopify:section:load',e=>boot(e.target));
})();
